var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_23050",
    "data-name": "Grupo 23050",
    xmlns: "http://www.w3.org/2000/svg",
    width: 216.241,
    height: 25.693,
    viewBox: "0 0 216.241 25.693",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_22738",
    "data-name": "Grupo 22738",
    transform: "translate(110.965 5.078)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1765",
    "data-name": "Caminho 1765",
    d: "M546.6,65.889V50.7h2.419V65.867H546.6Z",
    transform: "translate(-546.6 -49.567)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1766",
    "data-name": "Caminho 1766",
    d: "M579.223,68.629a4.823,4.823,0,0,1,1.242,3.421v6.8H578.09V72.53a3.225,3.225,0,0,0-.741-2.223,2.433,2.433,0,0,0-1.94-.828,3.036,3.036,0,0,0-2.462,1.068,4.664,4.664,0,0,0-.893,3.116V78.85H569.7V67.627h2.354V69a4.824,4.824,0,0,1,3.9-1.7A4.4,4.4,0,0,1,579.223,68.629Z",
    transform: "translate(-564.666 -62.549)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1767",
    "data-name": "Caminho 1767",
    d: "M630.662,67.065a5.54,5.54,0,0,1-2.789.872,4.066,4.066,0,0,1-2.964-1.046,4.147,4.147,0,0,1-1.09-3.094v-5.47H621.4V56.387h2.419V52.9h2.354v3.487h3.857v1.939h-3.857v5.3a2.2,2.2,0,0,0,.5,1.547,1.772,1.772,0,0,0,1.351.523,3.318,3.318,0,0,0,1.9-.61Z",
    transform: "translate(-605.1 -51.287)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1768",
    "data-name": "Caminho 1768",
    d: "M674.519,73.972H665.41a3.676,3.676,0,0,0,1.133,2.419,3.2,3.2,0,0,0,2.266.915,3.437,3.437,0,0,0,3.312-1.939l2.114.458a5.321,5.321,0,0,1-2.092,2.637,6.122,6.122,0,0,1-3.312.893,5.578,5.578,0,0,1-4.053-1.656,5.68,5.68,0,0,1-1.678-4.249,5.83,5.83,0,0,1,1.678-4.293,5.67,5.67,0,0,1,4.14-1.656,5.311,5.311,0,0,1,3.9,1.591,5.686,5.686,0,0,1,1.7,4.1v.785Zm-7.8-3.683a3.1,3.1,0,0,0-1.242,2.027H672.1a3.453,3.453,0,0,0-1.133-2.048,3.211,3.211,0,0,0-2.07-.7A3.405,3.405,0,0,0,666.717,70.289Z",
    transform: "translate(-637.712 -62.706)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1769",
    "data-name": "Caminho 1769",
    d: "M723,61.822V45.5h2.354V61.8H723Z",
    transform: "translate(-684.559 -45.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1770",
    "data-name": "Caminho 1770",
    d: "M746.171,47.036a1.431,1.431,0,0,1,.436,1.046,1.412,1.412,0,0,1-.414,1.046,1.517,1.517,0,0,1-1.068.414,1.479,1.479,0,0,1-1.09-.414,1.363,1.363,0,0,1-.436-1.046,1.431,1.431,0,0,1,.436-1.046,1.5,1.5,0,0,1,1.09-.436A1.352,1.352,0,0,1,746.171,47.036Zm-2.223,15.647V51.438H746.3V62.682Z",
    transform: "translate(-700.67 -46.36)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1771",
    "data-name": "Caminho 1771",
    d: "M774.5,77.947a4.978,4.978,0,0,1-1.569,3.9,6.13,6.13,0,0,1-4.249,1.395c-2.68,0-4.511-.893-5.492-2.7l1.918-1.416a4.481,4.481,0,0,0,1.46,1.525,4.019,4.019,0,0,0,2.092.479,3.271,3.271,0,0,0,3.53-3.508V76.9a5.093,5.093,0,0,1-3.879,1.395,5.39,5.39,0,0,1-3.857-1.591,5.369,5.369,0,0,1-.022-7.736,5.385,5.385,0,0,1,3.857-1.569,5.093,5.093,0,0,1,3.879,1.395V67.683h2.288V77.947Zm-3.312-2.659a3.162,3.162,0,0,0,1.024-2.462,3.237,3.237,0,0,0-1.024-2.462,3.532,3.532,0,0,0-2.462-.959,3.668,3.668,0,0,0-2.571.937,3.178,3.178,0,0,0-1.024,2.484,3.237,3.237,0,0,0,1.024,2.462,3.685,3.685,0,0,0,2.571.959A3.532,3.532,0,0,0,771.19,75.289Z",
    transform: "translate(-715.686 -62.628)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1772",
    "data-name": "Caminho 1772",
    d: "M835.519,73.972H826.41a3.675,3.675,0,0,0,1.133,2.419,3.293,3.293,0,0,0,2.266.915,3.437,3.437,0,0,0,3.312-1.939l2.114.458a5.32,5.32,0,0,1-2.092,2.637,6.122,6.122,0,0,1-3.312.893,5.578,5.578,0,0,1-4.053-1.656,5.68,5.68,0,0,1-1.678-4.249,5.83,5.83,0,0,1,1.678-4.293,5.67,5.67,0,0,1,4.141-1.656,5.311,5.311,0,0,1,3.9,1.591,5.686,5.686,0,0,1,1.7,4.1v.785Zm-7.78-3.683a3.1,3.1,0,0,0-1.242,2.027h6.625a3.452,3.452,0,0,0-1.133-2.048,3.211,3.211,0,0,0-2.07-.7A3.365,3.365,0,0,0,827.739,70.289Z",
    transform: "translate(-763.627 -62.706)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1773",
    "data-name": "Caminho 1773",
    d: "M893.423,68.629a4.823,4.823,0,0,1,1.242,3.421v6.8H892.29V72.53a3.225,3.225,0,0,0-.741-2.223,2.432,2.432,0,0,0-1.939-.828,3.036,3.036,0,0,0-2.463,1.068,4.664,4.664,0,0,0-.893,3.116V78.85H883.9V67.627h2.354V69a4.824,4.824,0,0,1,3.9-1.7A4.432,4.432,0,0,1,893.423,68.629Z",
    transform: "translate(-810.396 -62.549)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1774",
    "data-name": "Caminho 1774",
    d: "M944.862,67.065a5.54,5.54,0,0,1-2.789.872,4.066,4.066,0,0,1-2.964-1.046,4.147,4.147,0,0,1-1.09-3.094v-5.47H935.6V56.387h2.419V52.9h2.354v3.487h3.857v1.939h-3.857v5.3a2.2,2.2,0,0,0,.5,1.547,1.773,1.773,0,0,0,1.351.523,3.318,3.318,0,0,0,1.9-.61Z",
    transform: "translate(-850.829 -51.287)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1775",
    "data-name": "Caminho 1775",
    d: "M988.719,73.972H979.61a3.675,3.675,0,0,0,1.133,2.419,3.2,3.2,0,0,0,2.266.915,3.438,3.438,0,0,0,3.312-1.939l2.114.458a5.32,5.32,0,0,1-2.092,2.637,6.121,6.121,0,0,1-3.312.893,5.578,5.578,0,0,1-4.053-1.656,5.68,5.68,0,0,1-1.678-4.249,5.83,5.83,0,0,1,1.678-4.293,5.67,5.67,0,0,1,4.14-1.656,5.311,5.311,0,0,1,3.9,1.591,5.686,5.686,0,0,1,1.7,4.1v.785Zm-7.8-3.683a3.1,3.1,0,0,0-1.242,2.027H986.3a3.452,3.452,0,0,0-1.133-2.048,3.211,3.211,0,0,0-2.07-.7A3.405,3.405,0,0,0,980.917,70.289Z",
    transform: "translate(-883.442 -62.706)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_22743",
    "data-name": "Grupo 22743"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1776",
    "data-name": "Caminho 1776",
    d: "M142.5,45.407V24.4h4.271V45.407Z",
    transform: "translate(-119.597 -23.921)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1777",
    "data-name": "Caminho 1777",
    d: "M178.136,24.4a11.887,11.887,0,0,1,8.368,2.9,9.82,9.82,0,0,1,3.16,7.605,9.82,9.82,0,0,1-3.16,7.605,11.887,11.887,0,0,1-8.368,2.9H170.4V24.4Zm0,17.15a7.557,7.557,0,0,0,5.274-1.809,6.183,6.183,0,0,0,1.983-4.838,6.183,6.183,0,0,0-1.983-4.838,7.52,7.52,0,0,0-5.274-1.809h-3.487V41.55Z",
    transform: "translate(-141.417 -23.921)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1778",
    "data-name": "Caminho 1778",
    d: "M265.043,45.407l-1.809-4.489H253.95L252.1,45.407h-4.6L256.587,24.4h3.988l9.087,21.007Zm-6.45-15.843-3.073,7.5h6.1Z",
    transform: "translate(-201.715 -23.921)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1779",
    "data-name": "Caminho 1779",
    d: "M361.436,24.4a11.887,11.887,0,0,1,8.368,2.9,9.82,9.82,0,0,1,3.16,7.605,9.82,9.82,0,0,1-3.16,7.605,11.887,11.887,0,0,1-8.368,2.9H353.7V24.4Zm0,17.15a7.557,7.557,0,0,0,5.274-1.809,6.184,6.184,0,0,0,1.983-4.838,6.184,6.184,0,0,0-1.983-4.838,7.52,7.52,0,0,0-5.274-1.809h-3.487V41.55Z",
    transform: "translate(-284.772 -23.921)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1780",
    "data-name": "Caminho 1780",
    d: "M465.452,45.407H449.5V24.4h15.886v3.857H453.749v4.729h8.76v3.792h-8.76V41.55h11.7Z",
    transform: "translate(-359.695 -23.921)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3418",
    "data-name": "Ret\\xE2ngulo 3418",
    width: 4.228,
    height: 9.567,
    transform: "translate(7.845 10.547)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3419",
    "data-name": "Ret\\xE2ngulo 3419",
    width: 4.228,
    height: 8.76,
    transform: "translate(80.303 9.196)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3420",
    "data-name": "Ret\\xE2ngulo 3420",
    width: 4.228,
    height: 5.862,
    transform: "translate(76.25 12.509)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3421",
    "data-name": "Ret\\xE2ngulo 3421",
    width: 4.228,
    height: 5.862,
    transform: "translate(93.509 14.448)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3422",
    "data-name": "Ret\\xE2ngulo 3422",
    width: 4.228,
    height: 10.264,
    transform: "translate(63.676 11.201)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3423",
    "data-name": "Ret\\xE2ngulo 3423",
    width: 4.228,
    height: 11.005,
    transform: "translate(60.385 4.053)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3424",
    "data-name": "Ret\\xE2ngulo 3424",
    width: 4.228,
    height: 12.465,
    transform: "translate(32.601 8.63)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1781",
    "data-name": "Caminho 1781",
    d: "M54.42,35.776a6.055,6.055,0,0,1-1.983,3.073,6.267,6.267,0,0,1-3.988,1.308,6.452,6.452,0,0,1-4.772-2,6.853,6.853,0,0,1-1.961-4.99,6.873,6.873,0,0,1,1.939-4.969,6.412,6.412,0,0,1,4.794-1.983,6.248,6.248,0,0,1,3.966,1.308,6.068,6.068,0,0,1,1.9,2.7h4.467a9.634,9.634,0,0,0-3.617-5.84,11.335,11.335,0,0,0-14.557,1,10.523,10.523,0,0,0-3.2,7.78,10.537,10.537,0,0,0,3.2,7.8,11.315,11.315,0,0,0,14.579.937,9.84,9.84,0,0,0,3.6-6.145H54.42Z",
    transform: "translate(-37.4 -22.2)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3425",
    "data-name": "Ret\\xE2ngulo 3425",
    width: 4.228,
    height: 5.165,
    transform: "translate(4.075 12.465)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3426",
    "data-name": "Ret\\xE2ngulo 3426",
    width: 4.228,
    height: 4.293,
    transform: "translate(35.608 13.511)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3427",
    "data-name": "Ret\\xE2ngulo 3427",
    width: 1.155,
    height: 0.763,
    transform: "translate(10.133 11.31)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3428",
    "data-name": "Ret\\xE2ngulo 3428",
    width: 1.155,
    height: 0.763,
    transform: "translate(8.608 12.378)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3429",
    "data-name": "Ret\\xE2ngulo 3429",
    width: 1.155,
    height: 0.763,
    transform: "translate(10.133 13.446)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3430",
    "data-name": "Ret\\xE2ngulo 3430",
    width: 1.155,
    height: 0.763,
    transform: "translate(8.608 13.446)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3431",
    "data-name": "Ret\\xE2ngulo 3431",
    width: 1.155,
    height: 0.763,
    transform: "translate(10.133 14.513)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3432",
    "data-name": "Ret\\xE2ngulo 3432",
    width: 1.155,
    height: 0.763,
    transform: "translate(8.608 15.581)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_22739",
    "data-name": "Grupo 22739",
    transform: "translate(61.017 5.143)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3433",
    "data-name": "Ret\\xE2ngulo 3433",
    width: 1.155,
    height: 0.763,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3434",
    "data-name": "Ret\\xE2ngulo 3434",
    width: 1.155,
    height: 0.763,
    transform: "translate(1.525 1.068)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3435",
    "data-name": "Ret\\xE2ngulo 3435",
    width: 1.155,
    height: 0.763,
    transform: "translate(1.525 2.136)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3436",
    "data-name": "Ret\\xE2ngulo 3436",
    width: 1.155,
    height: 0.763,
    transform: "translate(0 3.203)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3437",
    "data-name": "Ret\\xE2ngulo 3437",
    width: 1.155,
    height: 0.763,
    transform: "translate(1.525 4.271)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3438",
    "data-name": "Ret\\xE2ngulo 3438",
    width: 1.155,
    height: 0.763,
    transform: "translate(78.691 13.533)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3439",
    "data-name": "Ret\\xE2ngulo 3439",
    width: 1.155,
    height: 0.763,
    transform: "translate(77.165 14.601)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3440",
    "data-name": "Ret\\xE2ngulo 3440",
    width: 1.155,
    height: 0.763,
    transform: "translate(77.165 15.668)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3441",
    "data-name": "Ret\\xE2ngulo 3441",
    width: 1.155,
    height: 0.763,
    transform: "translate(78.691 16.758)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3442",
    "data-name": "Ret\\xE2ngulo 3442",
    width: 1.155,
    height: 0.763,
    transform: "translate(78.691 17.826)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3443",
    "data-name": "Ret\\xE2ngulo 3443",
    width: 1.155,
    height: 0.763,
    transform: "translate(82.788 10.395)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3444",
    "data-name": "Ret\\xE2ngulo 3444",
    width: 1.155,
    height: 0.763,
    transform: "translate(81.262 11.484)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3445",
    "data-name": "Ret\\xE2ngulo 3445",
    width: 1.155,
    height: 0.763,
    transform: "translate(82.788 12.552)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3446",
    "data-name": "Ret\\xE2ngulo 3446",
    width: 1.155,
    height: 0.763,
    transform: "translate(81.262 13.62)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3447",
    "data-name": "Ret\\xE2ngulo 3447",
    width: 1.155,
    height: 0.763,
    transform: "translate(82.788 14.688)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3448",
    "data-name": "Ret\\xE2ngulo 3448",
    width: 1.155,
    height: 0.763,
    transform: "translate(82.788 15.756)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_22740",
    "data-name": "Grupo 22740",
    transform: "translate(65.093 12.138)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3449",
    "data-name": "Ret\\xE2ngulo 3449",
    width: 0.85,
    height: 0.567,
    transform: "translate(1.133)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3450",
    "data-name": "Ret\\xE2ngulo 3450",
    width: 0.85,
    height: 0.567,
    transform: "translate(1.133 0.785)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3451",
    "data-name": "Ret\\xE2ngulo 3451",
    width: 0.85,
    height: 0.567,
    transform: "translate(0 0.785)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3452",
    "data-name": "Ret\\xE2ngulo 3452",
    width: 0.85,
    height: 0.567,
    transform: "translate(0 1.591)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3453",
    "data-name": "Ret\\xE2ngulo 3453",
    width: 0.85,
    height: 0.567,
    transform: "translate(0 2.375)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3454",
    "data-name": "Ret\\xE2ngulo 3454",
    width: 0.85,
    height: 0.567,
    transform: "translate(1.133 3.182)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3455",
    "data-name": "Ret\\xE2ngulo 3455",
    width: 0.85,
    height: 0.567,
    transform: "translate(1.133 3.966)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3456",
    "data-name": "Ret\\xE2ngulo 3456",
    width: 0.85,
    height: 0.567,
    transform: "translate(0 3.966)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3457",
    "data-name": "Ret\\xE2ngulo 3457",
    width: 1.155,
    height: 0.763,
    transform: "translate(33.342 9.567)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3458",
    "data-name": "Ret\\xE2ngulo 3458",
    width: 1.155,
    height: 0.763,
    transform: "translate(34.889 10.634)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3459",
    "data-name": "Ret\\xE2ngulo 3459",
    width: 1.155,
    height: 0.763,
    transform: "translate(33.342 10.634)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3460",
    "data-name": "Ret\\xE2ngulo 3460",
    width: 1.155,
    height: 0.763,
    transform: "translate(34.889 11.724)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3461",
    "data-name": "Ret\\xE2ngulo 3461",
    width: 1.155,
    height: 0.763,
    transform: "translate(33.342 12.792)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3462",
    "data-name": "Ret\\xE2ngulo 3462",
    width: 1.155,
    height: 0.763,
    transform: "translate(34.889 13.86)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3463",
    "data-name": "Ret\\xE2ngulo 3463",
    width: 1.155,
    height: 0.763,
    transform: "translate(33.342 13.86)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3464",
    "data-name": "Ret\\xE2ngulo 3464",
    width: 1.155,
    height: 0.763,
    transform: "translate(33.342 14.927)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3465",
    "data-name": "Ret\\xE2ngulo 3465",
    width: 1.155,
    height: 0.763,
    transform: "translate(34.889 15.995)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3466",
    "data-name": "Ret\\xE2ngulo 3466",
    width: 1.155,
    height: 0.763,
    transform: "translate(34.889 17.063)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3467",
    "data-name": "Ret\\xE2ngulo 3467",
    width: 1.155,
    height: 0.763,
    transform: "translate(33.342 18.131)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3468",
    "data-name": "Ret\\xE2ngulo 3468",
    width: 0.85,
    height: 0.567,
    transform: "translate(38.441 14.012)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3469",
    "data-name": "Ret\\xE2ngulo 3469",
    width: 0.85,
    height: 0.567,
    transform: "translate(37.308 14.797)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3470",
    "data-name": "Ret\\xE2ngulo 3470",
    width: 0.85,
    height: 0.567,
    transform: "translate(38.441 15.581)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3471",
    "data-name": "Ret\\xE2ngulo 3471",
    width: 0.85,
    height: 0.567,
    transform: "translate(38.441 16.366)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3472",
    "data-name": "Ret\\xE2ngulo 3472",
    width: 0.85,
    height: 0.567,
    transform: "translate(37.308 17.15)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3473",
    "data-name": "Ret\\xE2ngulo 3473",
    width: 1.155,
    height: 0.763,
    transform: "translate(6.363 13.271)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3474",
    "data-name": "Ret\\xE2ngulo 3474",
    width: 1.155,
    height: 0.763,
    transform: "translate(4.816 13.271)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3475",
    "data-name": "Ret\\xE2ngulo 3475",
    width: 1.155,
    height: 0.763,
    transform: "translate(6.363 14.339)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3476",
    "data-name": "Ret\\xE2ngulo 3476",
    width: 1.155,
    height: 0.763,
    transform: "translate(4.816 15.407)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_22741",
    "data-name": "Grupo 22741",
    transform: "translate(94.664 15.167)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3477",
    "data-name": "Ret\\xE2ngulo 3477",
    width: 1.155,
    height: 0.763,
    transform: "translate(1.547)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3478",
    "data-name": "Ret\\xE2ngulo 3478",
    width: 1.155,
    height: 0.763
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3479",
    "data-name": "Ret\\xE2ngulo 3479",
    width: 1.155,
    height: 0.763,
    transform: "translate(1.547 1.068)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3480",
    "data-name": "Ret\\xE2ngulo 3480",
    width: 1.155,
    height: 0.763,
    transform: "translate(0 1.068)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3481",
    "data-name": "Ret\\xE2ngulo 3481",
    width: 1.155,
    height: 0.763,
    transform: "translate(1.547 2.157)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3482",
    "data-name": "Ret\\xE2ngulo 3482",
    width: 1.155,
    height: 0.763,
    transform: "translate(0 2.157)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3483",
    "data-name": "Ret\\xE2ngulo 3483",
    width: 1.155,
    height: 0.763,
    transform: "translate(1.547 3.225)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3484",
    "data-name": "Ret\\xE2ngulo 3484",
    width: 1.155,
    height: 0.763,
    transform: "translate(0 3.225)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3485",
    "data-name": "Ret\\xE2ngulo 3485",
    width: 1.155,
    height: 0.763,
    transform: "translate(1.547 4.293)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3486",
    "data-name": "Ret\\xE2ngulo 3486",
    width: 1.155,
    height: 0.763,
    transform: "translate(0 4.293)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3487",
    "data-name": "Ret\\xE2ngulo 3487",
    width: 1.155,
    height: 0.763,
    transform: "translate(1.547 5.361)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3488",
    "data-name": "Ret\\xE2ngulo 3488",
    width: 1.155,
    height: 0.763,
    transform: "translate(0 5.361)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_22742",
    "data-name": "Grupo 22742",
    transform: "translate(94.359 15.189)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3489",
    "data-name": "Ret\\xE2ngulo 3489",
    width: 1.155,
    height: 0.763,
    transform: "translate(1.547)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3490",
    "data-name": "Ret\\xE2ngulo 3490",
    width: 1.155,
    height: 0.763,
    transform: "translate(0 1.068)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3491",
    "data-name": "Ret\\xE2ngulo 3491",
    width: 1.155,
    height: 0.763,
    transform: "translate(0 2.136)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3492",
    "data-name": "Ret\\xE2ngulo 3492",
    width: 1.155,
    height: 0.763,
    transform: "translate(1.547 3.203)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a6a2e248d44fd09ca96907979446dd45.svg";
export { ForwardRef as ReactComponent };